import { IAnchorLink } from '@models/IAnchorLink';
import { ICTALinks } from '@models/ICTALinks';
import { ILink } from '@models/ILink';
import BackgroundColourEnum from '@models/enums/IBackgroundColourEnum';
import StickyNavigation from '@molecules/StickyNavigation/StickyNavigation';

interface Props {
  readonly items: IAnchorLink[];
  readonly ctaLinks?: ICTALinks;
  readonly backgroundColour:
    | BackgroundColourEnum.Black
    | BackgroundColourEnum.Grey;
  readonly returnLink: ILink;
  readonly showReturnLinkMobileOnly: boolean;
}

const AnchorNavigation = ({
  items,
  ctaLinks,
  backgroundColour,
  returnLink,
  showReturnLinkMobileOnly,
}: Props) => (
  <StickyNavigation
    anchorNavigationItems={items}
    ctaLinks={ctaLinks}
    backgroundColour={backgroundColour}
    returnLink={returnLink}
    showReturnLinkMobileOnly={showReturnLinkMobileOnly}
  />
);

export default AnchorNavigation;
